import React, { useEffect, useState } from "react";
import { Button, Modal, Form, Select, Input, InputNumber, Row, Col } from "antd";

// import SelectUser from "./SelectUser";
// import SelectOrderCar from "./SelectOrderCar";

import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as Utils from "../utils/utils";
import * as String from "../commons/string";

import { useAsyncAxios, utilAxiosWithAppToken, utilAxiosWithAuth } from "../utils/customAxios";
import moment from "moment";

function ModalAddPaidItems({
    paidItems,
    open,
    onChangedOpen,
    onAddPaidItems,
}: {
    paidItems?: Array<Types.RentPaidItemDto>;
    open: boolean;
    onChangedOpen: (open: boolean) => void;
    onAddPaidItems: (paidItems: Array<Types.RentPaidItemDto>, payments?: Array<Types.RentPaidItemDto>) => void;
}) {
    const { Option } = Select;

    const [selectedRentPaidItems, setSelectedRentPaidItems] = useState<Array<Types.RentPaidItemDto>>(paidItems || []);
    const [rentPaidItems, setRentPaidItems] = useState<Array<Types.RentPaidItemDto>>();

    useEffect(() => {
        requestGetRentPaidItems();
    }, []);

    const requestAxiosGetRentPaidItems = async () => {
        const response = await utilAxiosWithAppToken().get(Request.RENT_PAID_ITEMS_URL);
        return response.data;
    };

    const {
        loading: loadingGetRentPaidItems,
        error: errorGetRentPaidItems,
        data: resultGetRentPaidItems,
        execute: requestGetRentPaidItems,
    } = useAsyncAxios(requestAxiosGetRentPaidItems);

    useEffect(() => {
        if (resultGetRentPaidItems === null) return;
        console.log("resultGetRentPaidItems", resultGetRentPaidItems);

        setRentPaidItems(resultGetRentPaidItems.rentPaidItems);
    }, [resultGetRentPaidItems]);

    useEffect(() => {
        if (errorGetRentPaidItems === null) return;
        console.log("errorGetRentPaidItems", errorGetRentPaidItems);
    }, [errorGetRentPaidItems]);

    const handleClose = () => {
        onChangedOpen(false);
    };

    useEffect(() => {
        if (open === true) {
            setSelectedRentPaidItems(paidItems || []);
            Utils.addModalStack();
        } else {
            Utils.popModalStack();
        }
    }, [open]);

    return (
        <Modal
            centered
            forceRender
            closable={false}
            open={open}
            title="유료 대여 품목"
            onOk={handleClose}
            onCancel={handleClose}
            footer={[
                <Button key="back" onClick={handleClose}>
                    취소
                </Button>,
                <Button
                    key="setPassword"
                    type="primary"
                    onClick={() => {
                        if (!paidItems) return;
                        const diffItems = selectedRentPaidItems.filter((item) => {
                            return !paidItems.some((other) => other.rentPaidItemId === item.rentPaidItemId);
                        });
                        onAddPaidItems(selectedRentPaidItems, diffItems);
                    }}
                >
                    저장
                </Button>,
            ]}
        >
            <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: 5 }}>
                <Select
                    value={selectedRentPaidItems.filter((item) => item.rentPaidItemType === "TABLE_CHAIR")[0]?.rentPaidItemId}
                    onChange={(value) => {
                        if (!rentPaidItems) {
                            return;
                        }

                        const itemIndex = rentPaidItems.findIndex((item) => item.rentPaidItemId === value) ?? -1;
                        const nextSelectedItems = selectedRentPaidItems.filter((item) => item.rentPaidItemType !== "TABLE_CHAIR");

                        if (itemIndex > -1) {
                            nextSelectedItems.unshift(rentPaidItems[itemIndex]);
                        }

                        setSelectedRentPaidItems(nextSelectedItems);
                    }}
                    placeholder={"선택 안함"}
                    allowClear
                >
                    {rentPaidItems
                        ?.filter((item) => item.rentPaidItemType === "TABLE_CHAIR")
                        ?.map((item) => (
                            <Option key={item.rentPaidItemId} value={item.rentPaidItemId}>
                                <span>{item.rentPaidItemName}</span>
                            </Option>
                        ))}
                </Select>
                <Select
                    value={selectedRentPaidItems.filter((item) => item?.rentPaidItemType === "BEDDING_SET")[0]?.rentPaidItemId}
                    onChange={(value) => {
                        if (!rentPaidItems) {
                            return;
                        }

                        const itemIndex = rentPaidItems.findIndex((item) => item.rentPaidItemId === value) ?? -1;
                        const nextSelectedItems = selectedRentPaidItems.filter((item) => item.rentPaidItemType !== "BEDDING_SET");

                        if (itemIndex > -1) {
                            nextSelectedItems.push(rentPaidItems[itemIndex]);
                        }

                        setSelectedRentPaidItems(nextSelectedItems);
                    }}
                    placeholder={"선택 안함"}
                    allowClear
                >
                    {rentPaidItems
                        ?.filter((item) => item.rentPaidItemType === "BEDDING_SET")
                        ?.map((item) => (
                            <Option key={item.rentPaidItemId} value={item.rentPaidItemId}>
                                <span>{item.rentPaidItemName}</span>
                            </Option>
                        ))}
                </Select>
            </div>
        </Modal>
    );
}

export default ModalAddPaidItems;
